import React from 'react';

export const ClearCart = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--clear-cart';
  color = color || '#B30000';

  return (
    <svg width="20" height="20" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M3.99996 11.8333C4.35358 11.8333 4.69272 11.9738 4.94277 12.2238C5.19282 12.4739 5.33329 12.813 5.33329 13.1666C5.33329 13.5203 5.19282 13.8594 4.94277 14.1095C4.69272 14.3595 4.35358 14.5 3.99996 14.5C3.64634 14.5 3.3072 14.3595 3.05715 14.1095C2.8071 13.8594 2.66663 13.5203 2.66663 13.1666C2.66663 12.813 2.8071 12.4739 3.05715 12.2238C3.3072 11.9738 3.64634 11.8333 3.99996 11.8333ZM3.99996 11.8333H11.3333C11.0696 11.8333 10.8118 11.9115 10.5926 12.058C10.3733 12.2045 10.2024 12.4128 10.1015 12.6564C10.0006 12.9 9.97417 13.1681 10.0256 13.4268C10.0771 13.6854 10.2041 13.923 10.3905 14.1095C10.577 14.2959 10.8146 14.4229 11.0732 14.4744C11.3319 14.5258 11.5999 14.4994 11.8436 14.3985C12.0872 14.2976 12.2955 14.1267 12.442 13.9074C12.5885 13.6881 12.6667 13.4304 12.6667 13.1666M3.99996 11.8333L4 4.5M6.15933 3.9873L13.3333 4.49997L12.6667 9.16664H11.3333M8.66667 9.16664H4M2 2.5L14 14.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ClearCart;
